import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { IconWallet } from "@/components/HeaderIcons";

export const WalletChip = () => {
  const [balance, setBalance] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    api.get("/bullion/wallet").then(({ data }) => { if (alive) setBalance(data.balance); }).catch(() => {});
    return () => { alive = false; };
  }, [location.pathname]);

  return (
    <button data-testid="wallet-chip" onClick={() => navigate("/wallet")} title="BULLION COIN Wallet"
      className="hdr-icon h-9 px-1 flex items-center gap-1.5 hover:text-pb-red transition-colors">
      <IconWallet size={26} />
      <span className="font-mono text-xs font-bold">{balance != null ? balance.toFixed(0) : "—"}</span>
    </button>
  );
};
